import { LinearProgress, LinearProgressProps, linearProgressClasses } from "@mui/material";

export type CoreProgressProps = {
	/** The height of the component. @default 5 */
	height?: number | string;
	/** The width of the component.*/
	width?: number | string;
	/** If `true`, the bar will have rounded ends @default true*/
	rounded?: boolean;
	color?: string;
	backgroundColor?: string;
} & Omit<LinearProgressProps, "color">;

export function CoreProgressBar({
	height,
	width,
	color,
	backgroundColor = color,
	rounded = true,
	...props
}: CoreProgressProps) {
	return (
		<LinearProgress
			{...props}
			sx={{
				height: height ?? 5,
				width: width ?? "100%",
				borderRadius: rounded ? (height ?? 5) : 0,
				[`&.${linearProgressClasses.colorPrimary}`]: {
					backgroundColor: backgroundColor ? backgroundColor : "#e6e0e9",
				},
				[`& .${linearProgressClasses.bar}`]: {
					borderRadius: height,
					backgroundColor: color ? color : "#6750a4",
				},
				...props.sx,
			}}
		/>
	);
}
